"use client";

import { useState } from "react";
import Link from "next/link";
import { Menu, X } from "lucide-react";
import Image from "next/image";
import logo from "../../public/log.png";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-card shadow-sm sticky py-2 top-0 z-50">
      <div className="container-custom flex items-center justify-between h-16">
        <Link href="/" className="flex items-center space-x-2">
          <Image
            src={logo}
            width={400}
            height={100}
            alt="logo"
            className="w-[140px] h-[60px]"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-8">
          <Link
            href="/"
            className="text-foreground hover:text-primary font-medium transition-colors"
          >
            Home
          </Link>
          <Link
            href="/countries"
            className="text-foreground hover:text-primary font-medium transition-colors"
          >
            Top Destinations
          </Link>
          <Link
            href="/blog"
            className="text-foreground hover:text-primary font-medium transition-colors"
          >
            Blog
          </Link>
          <Link
            href="/about"
            className="text-foreground hover:text-primary font-medium transition-colors"
          >
            About
          </Link>
          <Link
            href="/contact"
            className="text-foreground hover:text-primary font-medium transition-colors"
          >
            Contact
          </Link>
        </nav>

        <div className="hidden lg:block">
          <Link href="/search" className="btn-primary">
            Find Tee Times
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-foreground"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-card border-t border-border">
          <div className="container-custom py-4 space-y-4">
            <Link
              href="/"
              className="block text-foreground hover:text-primary font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              href="/countries"
              className="block text-foreground hover:text-primary font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Top Destinations
            </Link>
            <Link
              href="/blog"
              className="block text-foreground hover:text-primary font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              href="/about"
              className="block text-foreground hover:text-primary font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link
              href="/contact"
              className="block text-foreground hover:text-primary font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <Link
              href="/booking"
              className="block btn-primary w-full text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Find Tee Times
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
